import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { Actions as DataLayerActions } from 'actions/shared/dataLayer'
import { getIsAdmin } from 'selectors/user/session'
import { getArtworkCategory, getArtworkId } from '../../selectors/artwork'
import type { SelectedFrameOption } from '../../selectors/product'
import { getCurrentTab, getSelectedProduct, getSelectedFrameOption } from '../../selectors/product'
import {
  getGalleryDimensions,
  getGalleryItems,
  getGalleryModalDimensions,
  isValidScreenOrientation,
} from '../../selectors/gallery'
import { GalleryItem } from '../../types'
const mapStateToProps = createStructuredSelector({
  artworkId: getArtworkId,
  artworkCategory: getArtworkCategory,
  currentTab: getCurrentTab,
  galleryDimensions: getGalleryDimensions,
  galleryItems: getGalleryItems,
  galleryModalDimensions: getGalleryModalDimensions,
  isAdmin: getIsAdmin,
  isValidScreenOrientation,
  selectedProduct: getSelectedProduct,
  selectedFrameOption: getSelectedFrameOption,
})

const mapDispatchToProps = (dispatch) => ({
  updateDataLayer: (payload: Record<string, any>) =>
    dispatch(DataLayerActions.UPDATE_DATALAYER(payload)),
})

export type ConnectorProps = {
  artworkId: number
  artworkCategory: string
  currentTab: string
  galleryDimensions: { width: number; height: number }
  galleryItems: Array<GalleryItem>
  galleryModalDimensions: Record<string, any>
  isAdmin: boolean
  isValidScreenOrientation: string
  updateDataLayer: (...args: Array<any>) => any
  selectedProduct: Record<string, any>
  selectedFrameOption: SelectedFrameOption
}
export default connect(mapStateToProps, mapDispatchToProps)
